import { VivliostyleConfigSchema } from './schema.js';

/**
 * Define the configuration for Vivliostyle CLI.
 */
export function defineConfig(
  config: VivliostyleConfigSchema,
): VivliostyleConfigSchema {
  return config;
}
